import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 86DC0560-F109-4301-ACC7-46A6F74F441A
 * name view-headline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-headline.svg
 * tags
 * - View 
 */
export const ViewHeadlineIcon = createSvgIcon(<><path d="M4,5V7H21V5M4,11H21V9H4M4,19H21V17H4M4,15H21V13H4V15Z" /></>, 'ViewHeadlineIcon');
export default ViewHeadlineIcon